// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__QdTwd","choiceBoxes":"toolbarselects_choiceBoxes__1_Zyu","simpleField":"toolbarselects_simpleField__bUje3"};